import { lazyLoad } from 'utils/loadable';

export const TaxpayerFieldRegistration = lazyLoad(
  () => import('./taxpayerFieldRegistration.page'),
  (module) => module.TaxpayerFieldRegistration
);
